module.exports = __webpack_public_path__ + "img/game--it-takes-two--esrb.093387d2.png";